import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { useApi } from '../../hooks/useApi';
import { useAuth } from '../../hooks/useAuth';
import { claimPendingReferral } from '../../utils/attribution';

function VkAuthCallbackPage() {
    const { request } = useApi();
    const { login } = useAuth();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [message, setMessage] = useState('Finishing VK sign-in...');
    const code = searchParams.get('code') || '';
    const state = searchParams.get('state') || '';
    const deviceId = searchParams.get('device_id') || '';
    const oauthError = searchParams.get('error') || '';
    const oauthErrorDescription = searchParams.get('error_description') || '';

    useEffect(() => {
        if (oauthError) {
            setMessage(oauthErrorDescription || oauthError);
            return;
        }

        if (!code || !state) {
            setMessage('VK sign-in could not be completed: missing code or state.');
            return;
        }

        let cancelled = false;

        const completeAuth = async () => {
            try {
                const tokenResponse = await request('/api/v1/auth/oauth/vk/complete', {
                    method: 'POST',
                    body: JSON.stringify({ code, state, device_id: deviceId || null }),
                });
                if (cancelled) return;
                login(tokenResponse);
                await claimPendingReferral(request, tokenResponse?.access_token);
                navigate('/', { replace: true });
            } catch (error) {
                if (!cancelled) {
                    setMessage(error.message || 'VK sign-in failed.');
                }
            }
        };

        completeAuth();

        return () => {
            cancelled = true;
        };
    }, [code, state, deviceId, oauthError, oauthErrorDescription, request, login, navigate]);

    return (
        <div className="app">
            <main className="app__shell">
                <section className="panel panel--auth">
                    <h1>VK sign-in</h1>
                    <p>{message}</p>
                    <Link className="button-link" to="/">
                        Back to home
                    </Link>
                </section>
            </main>
        </div>
    );
}

export default VkAuthCallbackPage;
